import React from 'react';
import { AlertCircle } from 'lucide-react';

// Definimos las interfaces para las props
interface FormData {
    allowPublish: boolean;
}

interface PublishSectionProps {
    formData: FormData;
    setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

const PublishSection: React.FC<PublishSectionProps> = ({ formData, setFormData }) => {
    return (
        <section className="space-y-6">
            <div className="pb-4 border-b border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <span className="bg-indigo-100 w-8 h-8 rounded-lg flex items-center justify-center mr-3">
            <AlertCircle size={18} className="text-indigo-600" />
          </span>
                    Publication Settings
                </h2>
            </div>

            <div className="flex items-start space-x-3">
                <input
                    type="checkbox"
                    id="allowPublish"
                    checked={formData.allowPublish}
                    onChange={(e) => setFormData(prev => ({ ...prev, allowPublish: e.target.checked }))}
                    className="mt-1 h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500 border-gray-300"
                />
                <label htmlFor="allowPublish" className="text-sm text-gray-700">
                    Enable campaign publication immediately after approval
                </label>
            </div>
        </section>
    );
};

export default PublishSection;
